;(function($){
  'use strict';

  /**
   * ムービー
   */
  function Movie() {
    this.movies = {};
    this.$elm = {
      youtube: $('.js-youtube'),
      thumb: $('.js-youtube-thumb'),
    }
  }

  Movie.prototype = {
    /**
     * Youtube埋め込み
     */
    embedYoutube: function () {
      var defer = new $.Deferred();
      var isResolved = false;
      var self = this;
      var tag = document.createElement('script')
      tag.src = 'http://www.youtube.com/iframe_api'

      var firstScriptTag = document.getElementsByTagName('script')[0]
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
  
      window.onYouTubeIframeAPIReady = function() {
        self.$elm.youtube.each(function() {
          var label = $(this).attr('data-label');
          self.movies[label] = new YT.Player(this, {
            width:      $(this).attr('data-width')  || 560,
            height:     $(this).attr('data-height') || 315,
            videoId:    $(this).attr('data-id')     || 'J96HTpXZUNQ',
            playerVars: {
              rel: 0,
              showinfo: 0
            },
            events: {
              onReady: function(e) {
                switch (label) {
                  // イベントエリアの動画は、再生時に遅延がないように0秒へシークしておく
                  case 'event_movie':
                    e.target.mute();
                    e.target.seekTo(0, true);
                    e.target.pauseVideo();
                    e.target.unMute();
                    break;
                  // モーダル動画の読み込み完了でresolve
                  case 'modal_movie':
                    isResolved = true;
                    defer.resolve();
                    break;
                }
              }
            }
          });
        });
      }

      // なにかしらの障害でYoutubeが読み込めなくても前へ進む
      setTimeout(function() {
        if (!isResolved) {
          defer.reject();
        }
      }, 10000);

      return defer.promise();
    },

    /**
     * ラベルを指定して再生
     */
    play: function(label) {
      this.movies[label].playVideo();
    },

    /**
     * サムネイルクリックで再生
     */
    bindThumbClick: function() {
      var self = this;
      var isClicked = false

      this.$elm.thumb.on('click', function() {
        if (isClicked) return;

        var target = $(this).attr('data-target');
        isClicked = true;
        self.movies[target].playVideo();

        TweenMax.to(this, 0.5, {
          alpha: 0,
          display: 'none',
          ease: Power1.easeOut
        });
      });
    }
  }

  window.Movie = Movie;
})(jQuery);